const CompanyInfo = ({ customer }) => {
  if (!customer) return null;

  return (
    <div className=" border border-gray-200 rounded-md p-1.5 shadow-sm">
      <h3 className="text-sm font-semibold mb-1 border-b text-gray-800 border-gray-200 pb-0.5">
        Customer Details
      </h3>
      <div className="flex flex-wrap gap-2">
        <div className="flex items-center gap-1">
          <span className="text-sm font-medium text-gray-600 min-w-[35px]">
            Name:
          </span>
          <span className="text-sm text-gray-900 font-medium">
            {customer?.fullName}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-sm font-medium text-gray-600 min-w-[35px]">
            Email:
          </span>
          <span className="text-sm text-gray-900">{customer?.email}</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-sm font-medium text-gray-600 min-w-[35px]">
            Phone:
          </span>
          <span className="text-sm text-gray-900">{customer?.phoneNo}</span>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
